export default __webpack_public_path__ + "static/media/panda.4313f8f8.svg";